import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { Banner, FooterForm, Hotel, InfoSection, Location, RegisterCards } from "../components";
import { tracking } from '../utils/tracking';
import { imgs } from '../assets/imgs';
import { useResizeImg } from '../hooks/useResizeImg';
import { updateTags } from "../utils/funcs";


export const Venue = () => {
   const [isLoading, setIsLoading] = useState(true);
   const imageSource = useResizeImg(imgs.venue.venueBannerDesktop, imgs.venue.venueBannerMobile)
   const cards = [
      {
         img: imgs.venue.venue,
         title: 'HOSTED AT THE WORLD FAMOUS COMPUTER HISTORY MUSEUM',
         content1: 'Step into the heart of innovation at Venture Summit West, hosted at the renowned Computer History Museum. Surround yourself with the rich tapestry of technological evolution as the museum offers the perfect backdrop for forging new connections and exploring the future of technology.',
         btnTxt: 'GET YOUR TICKET',
         btnLink: '/registration',
         btnId: 293
      },
   ];

   useEffect(() => {
      updateTags("Venture Summit West | Venue")
   }, [])

   return (
      <div className='venue'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               <h1 >Join us in California</h1>
            </section>
            <section>
               <Link to='/registration' onClick={() => tracking(293)} className="btn">GET YOUR TICKET</Link>
            </section>
         </Banner>
         {/* <InfoSection  img={imgs.venue.venueInfo}>
            <h1>This September, the New York Venture Summit returns with a bang!</h1>
            <span></span>
            <p>Take your place among the tech industry’s best and brightest for 2 days of ground-breaking content including panels and presentations that will showcase the most cutting-edge innovations in the world.  Experience a highly-filtered look at the technology destined to change future.</p>
            <p>Examine ideas with the industry’s leading visionaries and decision-makers in a relaxed and friendly atmosphere assured to engage, enlighten, and excite. With a renewed market momentum, and with innovation exploding, the New York Venture Summit is the premier event to make connections, get noticed, and get a first look at the technologies shaping our future.</p>
            <div className='btn-container'>
            <Link className='btn b2' to='/registration' onClick={() => tracking(294)} >Tickets</Link>
            </div>
         </InfoSection> */}
         <RegisterCards cards={cards} />
         <Location />
         {/* <Hotel /> */}
         <FooterForm />
      </div>
   )
}
